import axios from 'axios';
import { logError } from './../util/commonFunctions';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    credentials: 'include',
    'Access-Control-Allow-Methods': '*',
  },
});

export const getAccessToken = async (EMAIL, TOKEN) => {
  const REQ_BODY = {
    email: EMAIL,
    token: TOKEN,
  };
  const URL = '/user/generateauthtoken';
  const response = await instance.post(URL, REQ_BODY);
  return response.data;
};

export const generateAccessToken = async (email, token) => {
  await getAccessToken(email, token)
    .then(result => {
      sessionStorage.setItem('authDetails', JSON.stringify(result));
    })
    .catch(error => {
      logError('getAccessToken', error);
    });
};
